"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _callback = _interopRequireDefault(require("use-debounce/lib/callback"));

var _pipe = _interopRequireDefault(require("unmutable/pipe"));

var _dataparcels = _interopRequireDefault(require("dataparcels"));

var _dangerouslyUpdateParcelData = _interopRequireDefault(require("dataparcels/dangerouslyUpdateParcelData"));

var _setMeta = _interopRequireDefault(require("dataparcels/lib/parcelData/setMeta"));

var _ApplyBeforeChange = _interopRequireDefault(require("./util/ApplyBeforeChange"));

var _ParcelBoundaryEquals = _interopRequireDefault(require("./util/ParcelBoundaryEquals"));

var _pipeWithFakePrevParcel = _interopRequireDefault(require("./util/pipeWithFakePrevParcel"));

var _useParcelBufferInternalBuffer = _interopRequireDefault(require("./useParcelBufferInternalBuffer"));

var _useParcelBufferInternalKeepValue = _interopRequireDefault(require("./useParcelBufferInternalKeepValue"));

// $FlowFixMe - useState is a named export of react
var removeInternalMeta = function removeInternalMeta(action) {
  var _ref = action.payload.meta || {},
      _submit = _ref._submit,
      _reset = _ref._reset;

  var isInternalMeta = action.type === 'setMeta' && (_submit || _reset);
  return !isInternalMeta;
};

var _default = function _default(params) {
  var applyBeforeChange = (0, _ApplyBeforeChange.default)(params.beforeChange); //
  // parcel state and change logic
  //
  // outerParcel is locked to changes in props

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      outerParcel = _useState2[0],
      setOuterParcel = _useState2[1]; // innerParcel can deviate from props


  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      innerParcel = _useState4[0],
      setInnerParcel = _useState4[1]; // shouldKeepValue


  var shouldKeepValue = (0, _useParcelBufferInternalKeepValue.default)(params); //
  // inner parcel prep
  //
  // 1. always apply applyBeforeChange to inner parcel
  //    so changes to innerParcel go up through beforeChange functions
  // 2. always add and set buffer meta to be passed to innerParcel

  var applyBufferMeta = function applyBufferMeta(parcel) {
    return parcel.modifyDown((0, _dangerouslyUpdateParcelData.default)((0, _setMeta.default)({
      _submit: false,
      _reset: false
    })));
  };

  var applyModifiers = (0, _pipe.default)(applyBeforeChange, applyBufferMeta);

  var prepareKeepValue = function prepareKeepValue(parcel) {
    // set existing value and child on the new parcel from props
    var data = (0, _objectSpread2.default)({}, parcel.data, {
      value: innerParcel.value,
      child: innerParcel.child
    });

    var _parcel$_changeAndRet = parcel._changeAndReturn(function (parcel) {
      return parcel._setData(data);
    }),
        _parcel$_changeAndRet2 = (0, _slicedToArray2.default)(_parcel$_changeAndRet, 1),
        changedParcel = _parcel$_changeAndRet2[0];

    return changedParcel;
  };

  var prepareInnerParcelFromOuter = function prepareInnerParcelFromOuter() {
    // if keepValue is used, beforeChange is ignored
    if (params.keepValue) {
      return shouldKeepValue ? prepareKeepValue : function (parcel) {
        return parcel;
      };
    }

    return (0, _pipeWithFakePrevParcel.default)(outerParcel, applyBeforeChange); // ^ this runs newOuterParcel through beforeChange immediately
    // shoving lastReceivedOuterParcel in as a fake previous value
  }; //
  // buffer ref and functions
  //


  var internalBuffer = (0, _useParcelBufferInternalBuffer.default)({
    onReset: function onReset() {
      return setOuterParcel(null);
    },
    // ^ resets by recreating innerParcel from outerParcel
    onSubmit: function onSubmit(changeRequest) {
      changeRequest._revertCallback = function (changeRequest) {
        internalBuffer.unshift(changeRequest);
      };

      params.parcel.dispatch(changeRequest);
    } // ^ submits by dispatching the buffered change request

  }); //
  // debounce
  //

  var _useDebouncedCallback = (0, _callback.default)(internalBuffer.submit, params.debounce),
      _useDebouncedCallback2 = (0, _slicedToArray2.default)(_useDebouncedCallback, 3),
      debounceRelease = _useDebouncedCallback2[0],

  /* blank */
  callDebounceRelease = _useDebouncedCallback2[2];

  if (!params.debounce) {
    callDebounceRelease();
  } //
  // update inner parcel when outer parcel changes (or is first set)
  //


  var newInnerParcel;

  if (!outerParcel || !(0, _ParcelBoundaryEquals.default)(params.parcel, outerParcel)) {
    var handleChange = function handleChange(newParcel, changeRequest) {
      var debounce = params.debounce,
          _params$buffer = params.buffer,
          buffer = _params$buffer === void 0 ? true : _params$buffer,
          keepValue = params.keepValue; // remove buffer actions meta from change request
      // and push any remaining change into the buffer

      var actions = changeRequest._actions.filter(removeInternalMeta);

      if (actions.length > 0) {
        internalBuffer.push(changeRequest._create({
          actions: actions
        }));
      }

      if (buffer) {
        // if buffer is to be used, update inner parcel immediately
        // and request a debounced submit if debounce is set
        setInnerParcel(newParcel.pipe(applyModifiers));
        debounce && debounceRelease();
      } else {
        // if no buffer, just propagate it immediately
        internalBuffer.submit(); // if keepValue is true, the buffer is in change of its own state
        // rather than waiting for new props containing the new value

        keepValue && setInnerParcel(newParcel.pipe(applyModifiers));
      } // trigger buffer actions if meta says so


      var _newParcel$meta = newParcel.meta,
          _submit = _newParcel$meta._submit,
          _reset = _newParcel$meta._reset;
      _submit && internalBuffer.submit();
      _reset && internalBuffer.reset();
    };

    var newOuterParcel = params.parcel; // boundary split to ensure that inner parcels chain are
    // completely isolated from outer parcels chain

    newInnerParcel = params.parcel._boundarySplit({
      handleChange: handleChange
    }).pipe(prepareInnerParcelFromOuter(), applyModifiers);
    setInnerParcel(newInnerParcel);
    setOuterParcel(newOuterParcel);
  }

  var returnedParcel = innerParcel || newInnerParcel; //
  // parcel buffer control
  //

  var actions = internalBuffer.bufferState ? internalBuffer.bufferState.actions : [];
  var parcelControl = {
    submit: function submit() {
      return returnedParcel.setMeta({
        _submit: true
      });
    },
    reset: function reset() {
      return returnedParcel.setMeta({
        _reset: true
      });
    },
    buffered: actions.length > 0,
    actions: actions,
    _outerParcel: params.parcel
  }; //
  // return
  //

  return [returnedParcel, parcelControl];
};

exports.default = _default;